/* eslint-disable react/jsx-no-bind */
import { h, Component } from 'preact';
import { getPageConfig } from '../../../lib/device';
import cx from 'classnames';
import { trackingProvider, DIMENSION, trackProps } from '@cube/track';
import { Icon } from '@cube/blocks';
import dlv from 'dlv';
import { Autoplay } from '../../pieces/autoplay';
import { getCommonProps } from '../../../lib/page';
import { WeatherWidget } from '@cube/weather-widget';
import { getBucket } from '../../../lib/abtest';
import { DccWidget } from '@cube/dcc-widget-v2';
import { TaboolaJs } from '../../pieces/taboola-js';
import { SadlibAd } from '../../pieces/sadlib-ad';
import EmailPreviewP25 from '@cube/header-widget/src/components/emailpreviewP25';
import { GamePromotion } from '../../pieces/game-promotion';
import { configure } from '../../../config';
import style from './style';

const scrollToIdWithOffset = (id, offset = 80) => {
	const el = document.getElementById(id);
	if (el) {
		const y = el.getBoundingClientRect().top + window.scrollY - offset;
		window.scrollTo({ top: y, behavior: 'smooth' });
	}
};

export const ScrollLink = ({ href, children, ...props }) => {
	const handleClick = (e) => {
		if (href.startsWith('#')) {
			e.preventDefault();
			const id = href.replace('#', '');
			scrollToIdWithOffset(id, 120);
			history.pushState(null, '', href);
		}
	};

	return (
		<a href={href} onClick={handleClick} {...props}>
			{children}
		</a>
	);
};

@trackingProvider({
	[DIMENSION.componentpath]: 'HeroClusterP25'
})
@configure({
	emailPreview: 'headerWidget.emailPreview',
	pageConfig: 'singleCube.pages.homeP25'
	// TODO:  Update this to point to home config once we are done with P25 ABTesting
	// pageConfigP25: 'singleCube.pages.homeP25'
})
export default class HeroClusterP25 extends Component {
	state = {
		isFlyoutSticky: false,
		stickyStyle: {}
	};

	isTicking = false;

	emailLinkWrapperRef = null;

	captureEmailLinkWrapperRef = (ref) => {
		this.emailLinkWrapperRef = ref;
	};

	handleScroll = () => {
		if (!this.isTicking) {
			window.requestAnimationFrame(() => {
				this.updateStickyPosition();
				this.isTicking = false;
			});
			this.isTicking = true;
		}
	};

	updateStickyPosition = () => {
		const shouldBeSticky = window.scrollY > 100;

		if (shouldBeSticky) {
			if (this.emailLinkWrapperRef) {
				const headerEl = document.querySelector('header');
				const headerBottom = headerEl
					? headerEl.getBoundingClientRect().bottom
					: 0;

				if (headerBottom <= 0) {
					if (this.state.isFlyoutSticky) {
						this.setState({ isFlyoutSticky: false, stickyStyle: {} });
					}
					return;
				}

				const rect = this.emailLinkWrapperRef.getBoundingClientRect();
				const newStickyStyle = {
					left: `${rect.right}px`,
					top: `${headerBottom}px`
				};

				if (
					!this.state.isFlyoutSticky ||
					this.state.stickyStyle.left !== newStickyStyle.left ||
					this.state.stickyStyle.top !== newStickyStyle.top
				) {
					this.setState({
						isFlyoutSticky: true,
						stickyStyle: newStickyStyle
					});
				}
			}
		}
		else if (this.state.isFlyoutSticky) {
			this.setState({ isFlyoutSticky: false, stickyStyle: {} });
		}
	};

	handleEmailHover = (isHovering) => {
		if (typeof window === 'undefined') return;
		const emailEvent = new CustomEvent('emailButtonHover', {
			detail: { isHovering }
		});
		document
			.querySelectorAll('.emailLinkWrapper')
			.forEach((element) => element.dispatchEvent(emailEvent));
	};

	handleEmailMouseEnter = () => {
		this.handleEmailHover(true);
	};

	handleEmailMouseLeave = () => {
		this.handleEmailHover(false);
	};

	componentWillMount() {
		let pageConfig = getPageConfig(this.props?.pageConfig, 'desktop');
		// let pageConfigP25 = getPageConfig(this.props?.pageConfigP25, 'desktop');
		this.setState({ pageConfig });
	}

	componentDidMount() {
		document.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount() {
		document.removeEventListener('scroll', this.handleScroll);
	}

	renderNav(navItems, qeId, type = 'primary', emailPreview) {
		const navClass = cx(
			style.nav,
			type === 'primary' && style.navPrimary,
			type === 'secondary' && style.navSecondary,
			type === 'tertiary' && style.navTertiary
		);
		if (!navItems.length) return null;

		let emailLinkIndex = -1;
		if (navItems && navItems.length) {
			emailLinkIndex = navItems.findIndex((item) => item.title === 'Email');
		}

		return (
			<div className={navClass}>
				{navItems.map((item, i) => {
					const isEmailLink = i === emailLinkIndex;
					const isEmailPreviewEnabled = emailPreview && emailPreview.enabled;
					const showEmailPreview = isEmailPreviewEnabled && isEmailLink;

					if (!isEmailPreviewEnabled) {
						return (
							<div
								class={cx(style.link, style[item.btnType])}
								qid={`${qeId}-${type}-item-${i}`}
							>
								<ScrollLink
									href={dlv(item, 'link.href')}
									target={
										dlv(item, 'link.open_new_window') ? '_blank' : '_self'
									}
									rel="noopener noreferrer"
									{...trackProps(
										{
											[DIMENSION.contenttitle]: item.title,
											[DIMENSION.clickindex]: i + 1
										},
										this.context
									)}
								>
									<Icon name={item.icon} class={style.icon} />
									<span>{item.title}</span>
									{item.imageUrl && (
										<img class={style.image} src={item.imageUrl} />
									)}
								</ScrollLink>
							</div>
						);
					}

					return (
						<div
							class={cx(
								style.link,
								style[item.btnType],
								isEmailLink && isEmailPreviewEnabled && 'emailLinkWrapper'
							)}
							qid={`${qeId}-${type}-item-${i}`}
							onMouseEnter={
								showEmailPreview ? this.handleEmailMouseEnter : null
							}
							onMouseLeave={
								showEmailPreview ? this.handleEmailMouseLeave : null
							}
							ref={isEmailLink ? this.captureEmailLinkWrapperRef : null}
						>
							<ScrollLink
								href={dlv(item, 'link.href')}
								target={dlv(item, 'link.open_new_window') ? '_blank' : '_self'}
								rel="noopener noreferrer"
								class={isEmailLink && isEmailPreviewEnabled ? 'emailLink' : ''}
								onMouseEnter={
									showEmailPreview ? this.handleEmailMouseEnter : null
								}
								onMouseLeave={
									showEmailPreview ? this.handleEmailMouseLeave : null
								}
								{...trackProps(
									{
										[DIMENSION.contenttitle]: item.title,
										[DIMENSION.clickindex]: i + 1
									},
									this.context
								)}
							>
								<Icon name={item.icon} class={style.icon} />
								<span>{item.title}</span>
								{item.imageUrl && (
									<img class={style.image} src={item.imageUrl} />
								)}
							</ScrollLink>
							{showEmailPreview && (
								<EmailPreviewP25
									config={emailPreview}
									isSticky={this.state.isFlyoutSticky}
									stickyStyle={this.state.stickyStyle}
								/>
							)}
						</div>
					);
				})}
			</div>
		);
	}

	render({ width, qeId, emailPreview, ...props }, { pageConfig }) {
		return (
			<div class={style.heroRow}>
				<div class={style.leftRail}>
					<div class={style.mainNav}>
						<div className={style.leftHeroNavigation}>
							{this.renderNav(dlv(pageConfig, 'clusters.hero.primaryNav'), qeId, 'primary', emailPreview)}
							{this.renderNav(
								dlv(pageConfig, 'clusters.hero.secondaryNav'),
								qeId,
								'secondary',
								emailPreview
							)}
							{this.renderNav(
								dlv(pageConfig, 'clusters.hero.tertiaryNav'),
								qeId,
								'tertiary',
								emailPreview
							)}
						</div>
					</div>
					<div class={style.adContainer}>
						<SadlibAd id="sc_home_hero_sidebar" type="desktopRail" />
					</div>
				</div>
				<div class={style.heroMain}>
					<div class={style.heroMainRow}>
						<div class={style.heroMainCol}>
							<div class={style.dccContainer}>
								<DccWidget
									variant={getBucket(pageConfig.dccVariantCookie)}
									{...dlv(pageConfig, 'clusters.dcc')}
									{...getCommonProps(props)}
								/>
							</div>
						</div>

						<div class={style.rightRail}>
							<div class={style.autoPlay}>
								<Autoplay
									autoplay={dlv(pageConfig, 'autoplay')}
									taboola={dlv(pageConfig, 'taboola.autoplay')}
									id="sc_home_autoplay"
								/>
							</div>
							<div class={style.utilities}>
								<div class={style.weather}>
									<WeatherWidget {...getCommonProps(props)} />
								</div>
								<div class={style.games}>
									<GamePromotion
										p25
										moreLink={'/vertical/category/games'}
										isWideScreen={width >= 1536}
									/>
								</div>
							</div>
						</div>
					</div>

					<div class={style.taboolaCluster} id="taboola-wide-cluster">
						<div class={style.taboolaEmbed}>
							<TaboolaJs
								{...dlv(pageConfig, 'taboola.subDcc')}
								class={style.subDccCluster}
								qeId="sc-home-subdcc"
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
